import classNames from 'classnames';
import {CSSProperties, ReactNode} from 'react';

import Col from '../../../common/Col';
import Row from '../../../common/Row';

type Props = {
  className?: string;
  style?: CSSProperties;
  id?: string;
  icon: ReactNode;
  label?: string | ReactNode;
  sublabel?: string | ReactNode;
  rightAlignSublabel?: boolean;
  reversed?: boolean;
  danger?: boolean;
};

const InfoPill = ({
  id,
  label,
  sublabel,
  rightAlignSublabel,
  reversed,
  danger,
  style,
  icon,
  className,
  ...props
}: Props) => {
  return (
    <div
      id={id}
      className={classNames(
        'border-normal border-gray-100 shadow-solid-light-green bg-white text-primary-700 font-sans rounded-2xl p-xs min-w-[3rem] text-xl',
        className
      )}
      style={{...style, borderRadius: '8rem'}}
      {...props}
    >
      <Row className="space-x-5 justify-between items-center text-center leading-none">
        <Col>
          <div className="flex ml-2 my-0.5 h-[4.5rem] w-[4.5rem] align-center items-center">{icon}</div>
        </Col>
        <Col className={classNames('font-medium gap-2 grow justify-end', reversed && 'flex-col-reverse')}>
          {label && (
            <Row className={classNames('text-[1.8rem] font-medium', rightAlignSublabel && 'self-end')}>{label}</Row>
          )}
          {sublabel && (
            <Row className={classNames('text-[2.6rem] font-semibold whitespace-nowrap', danger && 'text-red-200')}>
              {sublabel}
            </Row>
          )}
        </Col>
        <Col className="w-3" />
      </Row>
    </div>
  );
};

export default InfoPill;
